import { ResidualValueStepText } from "./types";

export const RESIDUAL_VALUE_BASIC_STEP = 0;
export const RESIDUAL_VALUE_DETAILS_STEP = 1;
export const RESIDUAL_VALUE_EQUIPMENT_STEP = 2;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const RESIDUAL_VALUE_INTRO_TEXTS: Record<number, ResidualValueStepText> = {
  [RESIDUAL_VALUE_BASIC_STEP]: {
    title: "Izračunajte ostatak vrijednosti",
    description: "Odaberite vozilo iz kataloga. Sustav procjenjuje koliko će vozilo vrijediti na kraju ugovora.",
  },
  [RESIDUAL_VALUE_DETAILS_STEP]: {
    title: "Trajanje ugovora i kilometri",
    description: "Upišite početak financiranja, istek ugovora i kilometražu. Za rabljeno vozilo potrebni su i prva registracija i kilometri.",
  },
  [RESIDUAL_VALUE_EQUIPMENT_STEP]: {
    title: "Dodajte opremu vozila",
    description: "Označite dodatnu opremu koju vozilo ima. Ona podiže otkupnu i prodajnu vrijednost.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const RESIDUAL_VALUE_INTRO_SAMPLE = {
  jom: "JOM 104 223",
  contractMonths: 48,
  mileageKm: 0,
  mileageAtContractEnd: 120000,
  equipment: [
    { name: "Navigacijski sustav", price: 850 },
    { name: "Grijanje sjedala", price: 420 },
    { name: "Parkirni senzori", price: 380 },
  ],
  buybackValue: 14200,
  sellingValue: 16900,
};
